export function isStringDefined(value: string | undefined | null) {
  return value !== undefined && value !== null && value !== ''
}

export const isDefined = <T>(value: T | undefined | null): value is T => value !== undefined && value !== null
